<template>
  <div v-show="isLoaded" class="mAge-gate-section" v-observe-visibility="startAnimate">
    <div class="age--form">
      <div class="age--form__logo" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, -25);">
        <img class="logo_text" :src="logo" alt="Tecate 0.0">
      </div>
      <h2 class="age--form__welcome" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, -25);">
        <p class="tecate00">
          <span class="p1">Tecate <span class="highlight">Cero Cero</span> Alcohol</span>
        </p>
        <!-- <br> -->
        ¡BIENVENIDO!
      </h2>
      <p class="age--form__instruction" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, -25);">
        Indícanos tu fecha de
        nacimiento</p>
      <form id="form-date" onsubmit="">
        <div class="age--form__inputs">
          <div class="age--form__input">
            <input class="inputAge" type="number" name="day" id="day" placeholder="00"
              onKeyPress="if(this.value.length===2) return false" autofocus />
            <label class="inputAge-label" for="day">Día</label>
          </div>
          <div class="age--form__input">
            <input class="inputAge" type="number" name="month" id="month" placeholder="00"
              onKeyPress="if(this.value.length===2) return false" />
            <label class="inputAge-label" for="month">Mes</label>
          </div>
          <div class="age--form__input">
            <input class="inputAge" type="number" name="year" id="year" placeholder="0000"
              onKeyPress="if(this.value.length===4) return false" />
            <label class="inputAge-label" for="year">Año</label>
          </div>
        </div>
        <div class="form--error"></div>
        <div class="age--form__inputs">
          <button class="age--form__get--in" aria-label="Entrar">Entrar</button>
        </div>
        <p class="age--form__instruction" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, -15); text-transform: uppercase;">
          <br> <br>
          También puedes acceder usando una <br> red social o creando tu cuenta:
        </p>
        <!-- <div class="age--form__inputs">
          <button type="button" class="age--form__fb--in" aria-label="Entrar FB">Iniciar sesion con Facebook</button>
        </div> -->
        <FacebookButtonAgeGate @fbLogin="fbLogin"></FacebookButtonAgeGate>
      </form>
      <p class="age--disclaimer" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, -25);">AL ENVIAR ESTE FORMULARIO, ACEPTAS LA <a  @click="popUpModal('politics') & footerGA4Click('click', 'politica de privacidad', 'footer')"  target="_blank" rel="noopener noreferrer">POLÍTICA DE PRIVACIDAD</a>, <a @click="popUpModal('terms') & footerGA4Click('click', 'terminos y condiciones', 'footer')" target="_blank" rel="noopener noreferrer">TÉRMINOS Y CONDICIONES</a> Y <a @click="popUpModal('cookies') & footerGA4Click('click', 'politica de cookies', 'footer')" target="_blank" rel="noopener noreferrer">USO DE COOKIES</a> DE ESTE SITIO WEB. <br>
      ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, LEE NUESTRA POLÍTICA DE PRIVACIDAD Y USO DE COOKIES.</p>
    </div>
      <Modal
        v-if="showModal"
        v-bind:wichModal="wichModal"
        @close="showModal = false"
      />
  </div>
</template>

<script>
import logo from '@/assets/TECATELOGO_ROJO.png';
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import FacebookButtonAgeGate from '../components/FacebookButtonAgeGate';
import Modal from "@/components/Modal";
import moment from 'moment';
import tagFunctions from '@/utils/tagFunctions.js'
import {differenceInYears, format, parse, isValid} from 'date-fns'

export default {
  name: "AgeGate",
  components: { FacebookButtonAgeGate, Modal, },
  data() {
    return {
      logo,
      animate: false,
      invalidDate: 'Debes ingresar una fecha  válida',
      notAdult: 'Lo sentimos, debes ser mayor de edad para acceder a este sitio',
      year: null,
      isAdult: false,
      age: null,
      birthDay: null,
      dateInput: {
        dayInput: false,
        monthInput: false,
        yearInput: false
      },
      buttonEnter: null,
      inputsForm: null,
      showModal: false,
      wichModal: "terms",
    };
  },
  created() {
  },
  destroyed() {
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if (isVisible) {
        this.animate = true
      }
    },
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    form_interactionGA4Click(name, action) {
      tagFunctions.form_interactionPush(name, action);
    },
    footerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section);
    },
    // fbLogin(xeerpaNeeded){
    //   this.checkAdult(xeerpaNeeded.birthday);
    //   tagFunctions.user_interactionPush('login', 'facebook', 'login');
    //   const bDay = parse(`${xeerpaNeeded.birthday}`,'MM/dd/yyyy', new Date())

    //   if (this.isAdult) {
    //         this.showError('')
    //         this.buttonEnter.disabled = false
    //         this.setAgeGateTokenAction(true);
    //         localStorage.setItem('ageUserBirthYear', format(bDay, 'yyyy'))
    //         localStorage.setItem('ageGateToken', true)
    //         localStorage.setItem('network', 'Facebook')
    //         tagFunctions.evAgeGatePush('Intento', 'NA')
    //         tagFunctions.evAgeGatePush('Exito', 'NA')
    //         tagFunctions.methodPush('facebook');
    //       } else {
    //         this.showError(this.notAdult)
    //         this.buttonEnter.disabled = true
    //         tagFunctions.evAgeGatePush('Intento', 'NA')
    //         tagFunctions.evAgeGatePush('Error', this.notAdult)
    //       }
    // },
    fbLogin() {},
    parseFlexibleDate(rawDate) {
      const formats = ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd', 'yyyy/dd/MM', 'yyyy-MM-dd', 'yyyy-dd-MM', 'dd-MM-yyyy', 'MM-dd-yyyy' ];
      for (const formatStr of formats) {
        const parsed = parse(rawDate, formatStr, new Date());
        if (isValid(parsed)) {
          return parsed;
        }
      }
      const fallback = new Date(rawDate);
      return isValid(fallback) ? fallback : null;
    },
    xeerpaLogin() {
      tagFunctions.user_interactionPush('login', 'facebook', 'login');
      // Obtener el parámetro 't' desde la URL
      const paramT  = this.$route.query.t;
      if(paramT!= null) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        var urlencoded = new URLSearchParams();
        urlencoded.append("t", paramT);
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        fetch("https://login.heinekenmexico.com/api/connect/getUserData", requestOptions)
          .then(response => {
            // Primero, verifica si la respuesta de la red fue exitosa
            if (!response.ok) {
              // Si la respuesta no es OK (ej. 404, 500), lanza un error para que el bloque .catch lo maneje.
              throw new Error(`Error de red: ${response.status}`);
            }
            // Si la respuesta es exitosa, la convertimos a JSON.
            // Esto devuelve una promesa que resuelve con el objeto JSON parseado.
            return response.json();
          })
        .then(result => {
          //console.log("Objeto JSON completo:", result);
          // Si necesitas guardar todo el objeto en localStorage como JSON:
          localStorage.setItem('data', JSON.stringify(result));
          const social = result.data.sn;
          const location = result.data.formData.location;
          const rawBirthday = result.data.formData.birthday;
          //console.log("birthday (crudo):", rawBirthday);
          // Acceder a la propiedad 'birthday' dentro de 'data' y 'formData'
          const bDay = this.parseFlexibleDate(rawBirthday);
          if (!bDay) {
            //console.error("No se pudo interpretar la fecha:", rawBirthday);
            this.showWarning = true;
            this.failAgeGate('Formato de fecha inválido');
            return;
          }
          //console.log("Fecha de cumpleaños (parseada):", bDay);
          const today = new Date()
          const age = differenceInYears(today, bDay)
          //console.log("Edad calculada:", age)
          window.localStorage.setItem('ageUser', age)
          window.localStorage.setItem('ageUserBirthYear', format(bDay, 'yyyy'))
          window.localStorage.setItem('ageUserCountry', location)
          if (isNaN(age) || age < 18) {
            this.showError(this.notAdult)
            this.buttonEnter.disabled = true
            tagFunctions.evAgeGatePush('Intento', 'NA')
            tagFunctions.evAgeGatePush('Error', this.notAdult)
          } else {
            setTimeout(() => {
              this.showError('')
              this.buttonEnter.disabled = false
              this.setAgeGateTokenAction(true);
              localStorage.setItem('ageGateToken', true)
              localStorage.setItem('network', social)
              tagFunctions.evAgeGatePush('Intento', 'NA')
              tagFunctions.evAgeGatePush('Exito', 'NA')
              tagFunctions.methodPush('facebook');
              this.form_interactionGA4Click(window.localStorage.getItem("date"), "complete");
            }, 200);
          } 
        })
        .catch(error => console.log('Hubo un error en la petición o al procesar los datos:', error));
      }
    },
    changeFocus(elem){
      elem === 'age--form__get--in'
        ? document.getElementById('year').blur()
        : document.getElementById(elem).focus()
    },
    checkLength(event){
      if(event.target.id === 'year'){
        if (event.target.value.length === 4) {
          this.changeFocus('age--form__get--in')
        }
      }else if (event.target.value.length === 2) {
        event.target.id === 'day'
          ? this.changeFocus('month')
          : event.target.id === 'month'
            ? this.changeFocus('year')
            : null;
      }
    },
    checkAdult(_birthday){
      const today = moment()
      this.age = today.diff(_birthday, 'years')
      this.isAdult = this.age >= 18
      localStorage.setItem('ageUser', this.age)
      localStorage.setItem('ageUserBirthYear', this.year)
      this.form_interactionGA4Click(window.localStorage.getItem("date"), "complete");
    },
    showError(msg){
      tagFunctions.evAgeGatePush('Intento', 'NA')
      tagFunctions.evAgeGatePush('Error', msg)
      tagFunctions.form_sendPush('entrar', 'entrar')
      document.getElementsByClassName('form--error')[0].innerHTML = msg
    },
    checkNumbers(event){
      let maxNumber
      let index
      switch (event.target) {
        case this.inputsForm[0]:
          maxNumber = 31
          index = 'dayInput'
          break
        case this.inputsForm[1]:
          maxNumber = 12
          index = 'monthInput'
          break
        case this.inputsForm[2]:
          this.year = event.target.value
          maxNumber = moment().get('year');
          index = 'yearInput'
          break
      }
      if (event.target.value < 10 && event.target.value > 0) {
        event.target.value = '0' + parseInt(event.target.value)
      } else if (parseInt(event.target.value) === 0) {
        event.target.value = '00'
      }
      if (parseInt(event.target.value) > maxNumber) {
        this.showError(this.invalidDate)
        event.target.value = ''
      } else if (event.target.value !== '') {
        this.dateInput[index] = true
      }
      if (this.dateInput.dayInput && this.dateInput.monthInput && this.dateInput.yearInput) {
        this.showError('')
        this.year = this.inputsForm[2].value;
        this.birthDay = moment(this.year + '-' + this.inputsForm[1].value + '-' + this.inputsForm[0].value);
        const date = this.inputsForm[0].value + '-' + this.inputsForm[1].value + '-' + this.year
        window.localStorage.setItem("date", date);
        if(Number(this.year) < 1900){
          return;
        }
        if (isNaN(this.birthDay)) {
          this.showError(this.invalidDate)
          this.buttonEnter.disabled = true
        } else {
          this.checkAdult(this.birthDay)
          if (this.isAdult) {
            this.showError('')
            this.buttonEnter.disabled = false
          } else {
            this.showError(this.notAdult)
            this.buttonEnter.disabled = true
          }
        }
      }
    },
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
  },
  mounted() {
    this.xeerpaLogin();
    this.buttonEnter = document.getElementsByClassName('age--form__get--in')[0];
  
    this.inputsForm = document.querySelectorAll('input[type=number]')
    Array.from(this.inputsForm).forEach((element) => {
      element.addEventListener('input', this.checkLength)
      element.addEventListener('focusout', this.checkNumbers)
    });
    this.buttonEnter.disabled = true
    this.buttonEnter.addEventListener('click', (ev) => {
      ev.preventDefault()
      tagFunctions.evAgeGatePush('Intento', 'NA')
      tagFunctions.evAgeGatePush('Exito', 'NA')
      tagFunctions.form_sendPush('entrar', 'entrar');
      tagFunctions.methodPush('normal');
      localStorage.setItem('network', 'Normal');
      localStorage.setItem('ageGateToken', true);
      this.setAgeGateTokenAction(true);
    })
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/agegatem.scss";
</style>
